import { useContext } from 'preact/hooks';

import { VkCaptchaContext } from './VkCaptchaContext';

export const useVkCaptchaContext = () => {
  const contextValue = useContext(VkCaptchaContext);
  const { isCaptchaShown, isCaptchaPassed, setIsCaptchaShown, setIsCaptchaPassed } = contextValue;

  if (contextValue === undefined) {
    throw new Error('useVkCaptcha must be used within a VkCaptchaProvider');
  }

  const handleCaptchaOpen = () => {
    setIsCaptchaShown?.(true);
  };

  const handleCaptchaClose = () => {
    setIsCaptchaShown?.(false);
  };

  return {
    isCaptchaShown,
    isCaptchaPassed,
    setIsCaptchaPassed,
    handleCaptchaOpen,
    handleCaptchaClose,
  };
};
